module.exports = __webpack_public_path__ + "img/money-helper.63890036.png";